export interface SourceInfo {
  id: string;
  label: string;
  faviconUrl: string;
  color: string;
}

const SOURCE_MAP: Record<string, SourceInfo> = {
  partiful: {
    id: 'partiful',
    label: 'Partiful',
    faviconUrl: 'https://partiful.com/favicon.ico',
    color: '#FF5C5C',
  },
  luma: {
    id: 'luma',
    label: 'Luma',
    faviconUrl: 'https://lu.ma/favicon.ico',
    color: '#FF6B4A',
  },
  meetup: {
    id: 'meetup',
    label: 'Meetup',
    faviconUrl: 'https://www.meetup.com/favicon.ico',
    color: '#F65858',
  },
  eventbrite: {
    id: 'eventbrite',
    label: 'Eventbrite',
    faviconUrl: 'https://www.eventbrite.com/favicon.ico',
    color: '#F05537',
  },
  facebook: {
    id: 'facebook',
    label: 'Facebook',
    faviconUrl: 'https://www.facebook.com/favicon.ico',
    color: '#1877F2',
  },
  google: {
    id: 'google',
    label: 'Google',
    faviconUrl: 'https://www.google.com/favicon.ico',
    color: '#4285F4',
  },
  ticketmaster: {
    id: 'ticketmaster',
    label: 'Ticketmaster',
    faviconUrl: 'https://www.ticketmaster.com/favicon.ico',
    color: '#026CDF',
  },
  universe: {
    id: 'universe',
    label: 'Universe',
    faviconUrl: 'https://www.universe.com/favicon.ico',
    color: '#5B5EA6',
  },
};

export function getSourceInfo(source: string): SourceInfo {
  const normalized = source.toLowerCase().trim();
  return (
    SOURCE_MAP[normalized] ?? {
      id: normalized,
      label: source.charAt(0).toUpperCase() + source.slice(1),
      faviconUrl: '',
      color: '#6B7280',
    }
  );
}

export function getUniqueSourcesFromEvents(
  events: Array<{ source?: string }>
): SourceInfo[] {
  const seen = new Set<string>();
  const sources: SourceInfo[] = [];

  for (const event of events) {
    if (!event.source) continue;
    const normalized = event.source.toLowerCase().trim();
    if (seen.has(normalized)) continue;
    seen.add(normalized);
    sources.push(getSourceInfo(event.source));
  }

  return sources;
}
